import { useMemo } from 'react';
import Select from 'react-select';
import { Box } from '@chakra-ui/react';
import { FormControl } from 'components/ui';
import { useAffiliateLookup } from '../../api/affiliates/useAffiliateLookup';

const SignUpInfoAffiliateLookup = ({
  affiliateName,
  onAffilSelection,
  onClear,
}) => {
  const { affiliates: affiliatesSearchResults } = useAffiliateLookup({
    searchString: affiliateName || '',
  });

  const optionItems = useMemo(() => {
    return (
      affiliatesSearchResults?.map((affiliate) => {
        return {
          label: affiliate.name,
          value: affiliate.id,
          affiliate,
        };
      }) ?? []
    );
  }, [affiliatesSearchResults]);

  return (
    <Box w="100%" position="relative" zIndex={10}>
      <FormControl>
        <FormControl.Label>Select health plan</FormControl.Label>

        <Select
          isClearable={true}
          placeholder={'Type to search...'}
          components={{ IndicatorSeparator: () => null }}
          styles={{
            container: (base) => ({
              ...base,
              width: '100%',
            }),
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            control: (base) => ({
              ...base,
              width: '100%',
              borderRadius: '8px',
              backgroundColor: 'rgba(4, 51, 56, 0.05)',
              borderColor: 'transparent',
              boxShadow: 'none',
              height: 48,
              padding: '0px 8px',
            }),
          }}
          testID="signup-affiliate-input"
          menuPortalTarget={document.body}
          menuPosition="fixed"
          options={optionItems}
          accessibilityLabel="Choose health plan"
          onChange={(optionItem) => {
            if (!optionItem) {
              onClear();
              return;
            }
            onAffilSelection(optionItem.affiliate);
          }}
          value={
            !!affiliateName
              ? optionItems?.find(
                  (opt) => opt?.affiliate?.name === affiliateName
                )
              : null
          }
        />
      </FormControl>
    </Box>
  );
};

export default SignUpInfoAffiliateLookup;
